module.exports = __webpack_public_path__ + "static/img/1.163322f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/1.png
// module id = YiQS
// module chunks = 0